import { isString } from './isString';

import { LOCALE } from '../constants';

export function lowerFirst(input, locale = LOCALE) {
  if (!isString(input)) return '';
  return input.replace(/(^[a-z])/, (match) => match.toLocaleLowerCase(locale));
}
